import { render, staticRenderFns } from "./DistributionPointDetailsPanel.vue?vue&type=template&id=1cc6c524"
import script from "./DistributionPointDetailsPanel.vue?vue&type=script&lang=js"
export * from "./DistributionPointDetailsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports